// extracted by mini-css-extract-plugin
export var autoExpand = "_12-8";
export var container = "_12-7";
export var containerWidth = "_12-5";
export var disabled = "_12-2";
export var error = "_12-3";
export var fullWidth = "_12-6";
export var inputWrapper = "_12-0";
export var small = "_12-1";
export var textarea = "_12-4";